import React, { FC } from 'react';
import { Seo, useVitalMetric } from '@funtech-int/yango-shared';
import { Route } from '@funtech-int/rival-react';

import { routesMetric } from '../../lib/metrics';
import { useSeoDefaultValue } from '../../hooks/useSeoDefaultValue';
import { IntlProvider } from '../IntlProvider/IntlProvider';
import { Rum } from '../Rum/Rum';

import { ClientLayout } from './ClientLayout';

import '../../assets/styles/tooltip.css';
import 'normalize.css/normalize.css';
import '../../assets/styles/variables.css';
import '../../assets/styles/global.css';
import '../../assets/styles/theme.css';
import '../../assets/styles/fonts';
import '@funtech-int/yango-shared/dist/index.css';

export const Layout: FC = () => {
    const seoDefaultValues = useSeoDefaultValue();
    const routeMeasure = useVitalMetric(routesMetric, {
        routingStart: performance.now(),
    });

    return (
        <>
            <Rum />
            <IntlProvider>
                <Seo.Provider seoDefaultValues={seoDefaultValues}>
                    <ClientLayout>
                        <Route {...routeMeasure} />
                    </ClientLayout>
                </Seo.Provider>
            </IntlProvider>
        </>
    );
};
